import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=58722120&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style1 from "./Payment.vue?vue&type=style&index=1&id=58722120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58722120",
  null
  
)

export default component.exports